export default "__VITE_ASSET__DhWe8wq0__"